import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "./translation/en";
import { no } from "./translation/no";
import { sv } from "./translation/sv";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: en,
  nb: no, // Bokmål UI strings live in ./translation/no.js (legacy filename)
  no: no, // alias for stored settings / deep links
  se: sv,
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "nb",
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    fallbackLng: ["nb", "no", "en"],

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
